import { useHelpQuery } from ".";

export const useHelp = ({ load = false, programId }) => {
  const programHelp = useHelpQuery({ load, programId });
  return {
    programHelp,
  };
};
